@if (entry.base?.display) {
    <div [innerHTML]="fileContent"></div>
}